import { cx } from 'class-variance-authority';
const root = cx(['flex gap-200 items-center h-text-field-md']);
export const styles = {
    root,
};
